module.exports = __webpack_public_path__ + "static/img/dropshipping_cn.0e3c417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dropshipping_cn.jpg
// module id = PCLq
// module chunks = 1